import clsx from "clsx";
import Image from "next/image";
import { useRouter } from "next/router";
import { useEffect } from "react";

import Modal from "../modal";

import styles from "./location-amenities-modal.module.scss";

const LocationAmenitiesModal = ({ location, onRequestClose, ...props }) => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChangeStart = () => {
      onRequestClose();
    };

    router.events.on("routeChangeStart", handleRouteChangeStart);

    return () => {
      router.events.off("routeChangeStart", handleRouteChangeStart);
    };
  }, [router.events, onRequestClose]);

  return (
    <Modal onRequestClose={onRequestClose} {...props}>
      <div className={clsx("container", styles.LocationAmenitiesModal)}>
        <div className={styles.LocationWrapper}>
          <div className={styles.LocationAmenities}>
            <h3 className={styles.LocationName}>Amenities</h3>
            <div className={styles.LocationHeading}>
              <h2 className={styles.LocationAmenitiesHeading}>
                {location.name}
              </h2>
            </div>
            <p>Location Features</p>
          </div>
        </div>

        {location.serviceAmenitiesCollection.items.length > 0 && (
          <div className={styles.FeatureList}>
            <h3>Service Amenities</h3>

            {location.serviceAmenitiesCollection.items.map((feature) => (
              <div key={feature.title} className={styles.FeatureItem}>
                <label>{feature.title}</label>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        )}

        {location.spaceAmenitiesCollection.items.length > 0 && (
          <div className={styles.FeatureList}>
            <h3>Space Amenities</h3>

            {location.spaceAmenitiesCollection.items.map((feature) => (
              <div key={feature.title} className={styles.FeatureItem}>
                <label>{feature.title}</label>
                <p>{feature.description}</p>
              </div>
            ))}
          </div>
        )}

        {location.techAmenitiesCollection.items.length > 0 && (
          <div className={styles.FeatureList}>
            <h3>Tech Amenities</h3>

            {location.techAmenitiesCollection.items.map((feature) => (
              <div key={feature.title} className={styles.FeatureItem}>
                <label>{feature.title}</label>
                <p>{feature.description}</p>
                {feature.price && (
                  <p className={styles.Link}>{feature.price}</p>
                )}
              </div>
            ))}
          </div>
        )}

        <div className={styles.Footer}>
          <div>
            <h4>Want to get in touch?</h4>
            <p>
              Schedule a visit online,
              <br /> connect with us: info@eastroom.com <br />
              Or, call us at: (416) 628-5333
            </p>
          </div>
          <div className={styles.Logo}>
            <Image
              src="/images/logo.png"
              layout="fill"
              alt="East Room"
              objectFit="contain"
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default LocationAmenitiesModal;
